export default {
  title: "! Commandes pausées jusqu'à {{time}}",
  button: 'Reprendre',
  labels: {
    rest_of_day: 'fin de journée',
  },
};
